<mandates-input-field
  [parentForm]="parentForm"
  control="endDate"
  label="MANDATES.endDate"
  type="date"
  [minDate]="today"
  [isReadonly]="true"
></mandates-input-field>
